import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  FormControl,
  Alert,
} from "@mui/material";
import Langs from "../../../../../app/lang/langs";
import { CustomColorPicker } from "../../../../../components/inputs/CustomColorPicker";
import { INPUT_SX, SELECT_SX } from "../constants";
import { minutesToTimeStr, timeStrToMinutes } from "../utils/formHelpers";
import FieldRow from "./FieldRow";

export default function SampleShiftBody({
  selectedFormData,
  formError,
  settings,
  dynamicLeaves,
  handlers,
  handleColorChange,
}) {
  const { onTimeFromChange, onTimeToChange, handleShiftTypeChange, handleTaskNameChange } = handlers;

  return (
    <Box sx={{ px: 2.5, pt: 2, pb: 12 }}>
      {/* Start time */}
      <FieldRow label="START_TIME">
        <TextField
          type="time"
          size="small"
          fullWidth
          value={minutesToTimeStr(selectedFormData.timeFrom)}
          onChange={(e) => onTimeFromChange(timeStrToMinutes(e.target.value))}
          sx={INPUT_SX}
          inputProps={{ style: { fontSize: "16px" } }}
        />
      </FieldRow>

      {/* End time */}
      <FieldRow label="END_TIME">
        <TextField
          type="time"
          size="small"
          fullWidth
          value={minutesToTimeStr(selectedFormData.timeTo)}
          onChange={(e) => onTimeToChange(timeStrToMinutes(e.target.value))}
          sx={INPUT_SX}
          inputProps={{ style: { fontSize: "16px" } }}
        />
      </FieldRow>

      {/* Task name */}
      <FieldRow label="TASK" error={formError === "MISSING_TASK"}>
        <TextField
          fullWidth
          size="small"
          value={selectedFormData.task || ""}
          onChange={handleTaskNameChange}
          error={formError === "MISSING_TASK"}
          inputProps={{ maxLength: 50, style: { fontSize: "16px" } }}
          sx={INPUT_SX}
        />
      </FieldRow>

      {/* Type */}
      <FieldRow label="TYPE">
        <FormControl fullWidth size="small" sx={SELECT_SX}>
          <Select
            value={selectedFormData.type || ""}
            onChange={(e) => handleShiftTypeChange(e.target.value)}
            sx={{ fontSize: "16px" }}
          >
            {(settings.shiftTypes || []).map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                <Langs str={opt.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FieldRow>

      {/* Color */}
      {!["AST"].includes(selectedFormData.type) &&
        !dynamicLeaves[selectedFormData.type] && (
          <FieldRow label="COLOR">
            <Box
              sx={{
                p: 1.5,
                borderRadius: "12px",
                border: "1px solid rgba(0,0,0,0.08)",
                bgcolor: "rgba(255,255,255,0.6)",
              }}
            >
              <CustomColorPicker
                color={selectedFormData.color}
                colors={settings.shiftColors}
                onChange={handleColorChange}
              />
            </Box>
          </FieldRow>
        )}

      {/* Error */}
      {formError && (
        <Alert severity="error" sx={{ mt: 2, borderRadius: "12px", fontSize: "0.85rem" }}>
          <Langs str={formError} />
        </Alert>
      )}
    </Box>
  );
}
